import { generatePath } from '@helpers/utils/paths/paths';
import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { appPaths } from '@terminal/routes/app-paths';
import { queryKeys } from '@terminal/routes/query-params';

export const useGetLinkToCompaniesSubtab = (themeId: string) => {
  const { params } = useQueryParams();

  return generatePath({
    basePath: `${appPaths.themeOverview}/${themeId}`,
    params: {
      ...params,
      [queryKeys.activeSubTab]: 'companies',
    },
  });
};
